import { AxiosResponse } from 'axios';
import { APIResponseSuccess } from '@/lib/types/request/types';
import { WorkDetailsEndEmployment } from '@/modules/people/store/work-detail';
import { patch } from '@webapp-next/lib/request/webapp/apiv2';

export default async function patchEndEmployment(
  employeeId: number,
  patchData: WorkDetailsEndEmployment
): Promise<APIResponseSuccess> {
  const body = {
    data: patchData,
    patchMask:
      'employmentEndDate,employmentEndReason,employmentEndSentiment,employmentEndComment',
  };

  const { data }: AxiosResponse<APIResponseSuccess> = await patch(
    `/api/management/v2/employees/${employeeId}`,
    body
  );

  return data;
}
